var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'visible': _vm.visible}},[_c('a',{staticClass:"button",attrs:{"href":"https://www.go2roues-assurance.fr/","target":"_blank","rel":"noopener"}},[_vm._v("OBTENIR UN DEVIS D'ASSURANCE →")])])}
var staticRenderFns = []

export { render, staticRenderFns }